import { request } from './client';

export type Option = { id: string; label: string };

export type ActivityField =
	| { id: string; type: 'content'; content: string }
	| {
			id: string;
			type: 'short_text';
			label: string;
			placeholder?: string;
			required: boolean;
	  }
	| {
			id: string;
			type: 'long_text';
			label: string;
			placeholder?: string;
			required: boolean;
	  }
	| {
			id: string;
			type: 'multiple_choice';
			label: string;
			options: Option[];
			required: boolean;
	  }
	| {
			id: string;
			type: 'checkbox';
			label: string;
			options: Option[];
			required: boolean;
	  }
	| { id: string; type: 'date'; label: string; required: boolean }
	| { id: string; type: 'image'; url: string; title?: string }
	| { id: string; type: 'video'; url: string; title?: string }
	| { id: string; type: 'audio'; url: string; title?: string }
	| {
			id: string;
			type: 'file';
			label: string;
			accept?: string;
			required: boolean;
	  };

export type ActivitySchema = {
	version: '2.0';
	content: Record<string, unknown>; // TipTap JSONContent
};

export type Activity = {
	id: number;
	program_id: number;
	template_id: number | null;
	is_from_library: boolean;
	schema: ActivitySchema;
	settings: { title?: string; [key: string]: unknown };
	week: number;
	day: number;
	position: number;
	created_at: string;
};

export type ActivityCompletion = {
	id: number;
	enrollment_id: number;
	client_id: number;
	activity_id: number;
	program_id: number;
	response_data: Record<string, unknown>;
	completed_at: string;
	created_at: string;
};

export const activitiesApi = {
	get: (programId: number, activityId: number) =>
		request<Activity>(`/programs/${programId}/activities/${activityId}`),

	update: (
		programId: number,
		activityId: number,
		data: { schema?: ActivitySchema; settings?: object },
	) =>
		request<Activity>(`/programs/${programId}/activities/${activityId}`, {
			method: 'POST',
			data,
		}),

	getCompletions: (programId: number, enrollmentId: number) =>
		request<{ completions: ActivityCompletion[]; total: number }>(
			`/programs/${programId}/activities/completions?enrollment_id=${enrollmentId}`,
		),
};
